/**
 * Created by mukund on 1/5/18.
 *
 * AngularJS directive for PnP Course Copy Wizard
 */

angular.module('mediacloudApp')
    .directive('courseCopyWizard', ['$filter', '$log', 'CollectionService', 'SearchService', 'Principal', function($filter, $log, CollectionService, SearchService, Principal){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/course-copy-wizard/course-copy-wizard.html',
            scope: {
                parent: '=',
                activeLink: '=',
                getParent: '&',
                copyOf: '=',
                oldCourses: '='
            },
            link: function(scope, element, attrs){

                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                scope.coursesPerPage = 10;

                var resetWizard = function(){
                    scope.searchField = {
                        query: '',
                        active: false
                    };
                    scope.copyInProgress = false;
                    clearCourses();
                };

                var clearCourses = function(){
                    scope.selectedCourse = null;
                    scope.parentPresent = false;
                    scope.courses = [];
                    scope.totalCourses = 0;
                    scope.currentPage = 1;
                };

                scope.skip = function(){
                    switchToPnP();
                };

                var switchToPnP = function(){
                    scope.$parent.$parent.activeLink = 'pnp';
                    resetWizard();
                };

                scope.selectCourse = function(course){
                    scope.selectedCourse = course;
                };

                var processResponse = function(result){
                    if (result.collections && result.collections.length > 0) {
                        var filteredCourses = $filter('filter')(result.collections, {cid: '!'+scope.parent.cid}, true);
                        if(filteredCourses.length !== result.collections.length){
                            scope.courses = scope.courses.concat(filteredCourses);
                            scope.parentPresent = true;
                            scope.totalCourses = result.totalCollections - 1;
                        } else {
                            scope.courses = scope.courses.concat(result.collections);
                        }
                        scope.totalCourses = scope.parentPresent ? result.totalCollections - 1 : result.totalCollections;
                    }
                };

                scope.showPriorCourses = function(){
                    scope.launch = false;
                    processResponse(scope.oldCourses);
                };

                scope.loadPriorCourses = function(){
                    scope.launch = false;
                    CollectionService.getCollections({
                        type: 'COURSE',
                        limit: scope.coursesPerPage,
                        offset: (scope.currentPage - 1) * scope.coursesPerPage,
                        paginated: true,
                        rw: true
                    }).then(function(response){
                        processResponse(response);
                    }).catch(function(err) {
                        scope.error = err;
                        $log.error("An error occurred when trying to fetch collections");
                    });
                };

                scope.checkForEnterKey = function(event, action){
                    if(event.keyCode === 13){
                        if(action === "search") {
                            scope.searchResolved = false;
                            scope.currentPage = 1;
                            scope.searchForCourses();
                        }
                    }
                };

                scope.searchForCourses = function(){
                    if(scope.searchField.query){
                        scope.lastSearchQuery = scope.searchField.query;
                        // Handles the transition from course list to search results
                        if(!scope.searchField.active){
                            scope.currentPage = 1;
                            scope.searchField.active = true;
                        }
                        SearchService.searchForCollections({
                            query: scope.searchField.query,
                            sitewide: true,
                            limit: scope.coursesPerPage,
                            offset: (scope.currentPage - 1) * scope.coursesPerPage,
                            rw: true,
                            type: 'COURSE'
                        }).then(function(response){
                            if(scope.currentPage === 1){
                                clearCourses();
                            }
                            processResponse(response);
                            scope.searchResolved = true;
                        }).catch(function(err) {
                            scope.error = err;
                            $log.error("An error occurred when trying to search for collections");
                        });
                    } else {
                        resetWizard();
                        scope.loadPriorCourses();
                    }
                };

                scope.cancelSearch = function(){
                    resetWizard();
                    scope.loadPriorCourses();
                };

                scope.loadMoreCourses = function(){
                    scope.currentPage++;
                    if(scope.searchField.active){
                        scope.searchForCourses();
                    } else {
                        scope.loadPriorCourses();
                    }
                };

                scope.copyCourse = function(){
                    if(scope.selectedCourse){
                        scope.copyInProgress = true;
                        CollectionService.copyCollection({
                            destinationCid: scope.parent.cid,
                            cidList: [scope.selectedCourse.cid]
                        }).then(function(response){
                            scope.copyOf.courseName = scope.selectedCourse.title;
                            scope.getParent();
                            resetWizard();
                        }).catch(function(err) {
                            scope.error = err;
                            $log.error("An error occurred when trying to copy the collection");
                        });
                    }
                };

                scope.cancelCourseCopy = function(){
                    scope.selectedCourse = null;
                    scope.skip();
                };

                scope.$watch('activeLink', function(){
                    if(scope.activeLink && scope.activeLink === 'copywizard'){
                        resetWizard();
                        scope.launch = true;
                    }
                });
            }
        }

    }]);
